import "./index.scss";
import ShippingList from "../../components/Shipping";
export const Shipping = () => {
  return (
    <div>
      <ShippingList />
    </div>
  );
};
